var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewTabIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,12c-0.6,0-1,0.4-1,1v6c0,0.6-0.4,1-1,1H5c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h6c0.6,0,1-0.4,1-1s-0.4-1-1-1H5 C3.3,5,2,6.3,2,8v11c0,1.7,1.3,3,3,3h11c1.7,0,3-1.3,3-3v-6C19,12.4,18.6,12,18,12z M21.9,2.6c-0.1-0.2-0.3-0.4-0.5-0.5 C21.3,2,21.1,2,21,2h-6c-0.6,0-1,0.4-1,1s0.4,1,1,1h3.6l-9.3,9.3c-0.4,0.4-0.4,1,0,1.4C9.5,14.9,9.7,15,10,15s0.5-0.1,0.7-0.3 L20,5.4V9c0,0.6,0.4,1,1,1s1-0.4,1-1V3C22,2.9,22,2.7,21.9,2.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTabIcon);
export default __webpack_public_path__ + "static/media/NewTabIcon.adb0b120ecbcf3919d389eb20dd746f8.svg";
export { ForwardRef as ReactComponent };